import { API_TAGS } from '../../constants/api';
import { apiSlice } from '../apiSlice';
import { API_TOPIC_MODELLER_URL } from '../../constants/env';
import { MESSAGES } from './topicModellingJobsMessages';

export const topicModellingJobsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchTopicModellingJobs: builder.query({
      query: () => ({
        url: `jobs/`,
        method: 'GET',
        API_URL: API_TOPIC_MODELLER_URL,
        params: {},
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_TOPIC_MODELLING_JOBS.ERROR
        }

      }),
      providesTags: (result, error, args) => {
        if (error?.error) {
          return [{ type: API_TAGS.TOPIC_MODELLING_JOBS, id: 'LIST' }];
        }
        return [
          { type: API_TAGS.TOPIC_MODELLING_JOBS, id: 'LIST' }
        ];
      }
    }),
    fetchTopicModellingJob: builder.query({
      query: ({ jobId }) => ({
        url: `jobs/${jobId}`,
        method: 'GET',
        API_URL: API_TOPIC_MODELLER_URL,
        params: {},
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_TOPIC_MODELLING_JOB.ERROR
        }
      })
    }),
    fetchTopicModellingJobTopics: builder.query({
      query: ({ jobId }) => ({
        url: `jobs/${jobId}/topics`,
        method: 'GET',
        API_URL: API_TOPIC_MODELLER_URL,
        params: {},
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_TOPIC_MODELLING_JOB_TOPICS.ERROR
        }
      })
    }),
    fetchTopicModellingJobCorpus: builder.query({
      query: ({ jobId }) => ({
        url: `jobs/${jobId}/corpus`,
        method: 'GET',
        API_URL: API_TOPIC_MODELLER_URL,
        params: {},
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_TOPIC_MODELLING_JOB_CORPUS.ERROR
        }
      })
    }),
    createTopicModellingJob: builder.mutation({
      query: ({ data }) => ({
        url: `jobs/`,
        method: 'POST',
        API_URL: API_TOPIC_MODELLER_URL,
        body: data,
        params: {},
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.CREATE_TOPIC_MODELLING_JOB.ERROR
        },
        successMessage: {
          showMessage: true,
          messages: MESSAGES.CREATE_TOPIC_MODELLING_JOB.SUCCESS
        }
      })
    })
  })
});

export const {
  useFetchTopicModellingJobsQuery,
  useFetchTopicModellingJobQuery,
  useFetchTopicModellingJobTopicsQuery,
  useLazyFetchTopicModellingJobTopicsQuery,
  useFetchTopicModellingJobCorpusQuery,
  useCreateTopicModellingJobMutation
} = topicModellingJobsSlice;
